import { createStore } from "vuex";
import type { RootState } from "./types";

import auth from "@/store/modules/auth";
import ui from "@/store/modules/ui";
import editor from "@/store/modules/editor";
import campaign from "@/store/modules/campaign";
import deliverableLibrary from "@/store/modules/deliverableLibrary";
import jobs from "@/store/modules/jobs";
import masterTemplateLibrary from "@/store/modules/masterTemplateLibrary";
import notifications from "@/store/modules/notifications";
import roles from "@/store/modules/roles";
import mediaLibrary from "@/store/modules/mediaLibrary";

const store = createStore<RootState>({
    modules: {
        auth,
        campaign,
        deliverableLibrary,
        editor,
        jobs,
        masterTemplateLibrary,
        mediaLibrary,
        notifications,
        roles,
        ui
    }
});

export default store;
